/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { get } from 'lodash-es';
// import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { fromJS } from 'immutable';
import { Tooltip } from '../../Components/Tooltip';
import { FormatedDate } from '../../Components/FormatedDate';

import { theme } from '../../Theme/theme';

export const columns = (handleOnClick, strings, i18n) => {
  const uid = 'id';

  // TODO: https://github.com/bvaughn/react-virtualized/blob/master/source/CellMeasurer/CellMeasurer.DynamicHeightTableColumn.example.js#L70-L94
  // eslint-disable-next-line
  const StatusColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    let label;
    switch (cellData) {
      case 'submitted':
        label = strings['quotations.filter.status.options.submitted.label'] || 'Submitted';
        break;
      case 'canceled':
        label = strings['quotations.filter.status.options.canceled.label'] || 'Canceled';
        break;
      case 'project':
        label = strings['quotations.filter.status.options.project.label'] || 'Project';
        break;
      case 'pending':
        label = strings['quotations.filter.status.options.pending.label'] || 'Pending';
        break;

      default:
        label = cellData;
        break;
    }
    try {
      cell = (
        <div
          title={label}
          style={{
            alignItems: 'center',
            justifyContent: 'left',
            display: 'flex',
          }}
        >
          <div className={`status ship2 ${cellData}`} />
          <div className={`status label ${cellData}`}>{label}</div>
        </div>
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  // eslint-disable-next-line no-unused-vars
  const ActionsColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return strings[action.get('label')];
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      cellData.forEach(action => {
        if (action.get('type') === 'action') {
          actions.push(
            <Tooltip
              key={`tooltip-${action.get('route')}-${rowData.get(uid)}`}
              title={strings[action.get('label')] || ''}
              placement="left"
            >
              <IconButton
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
                onClick={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: rowData.get(uid),
                  })
                }
                onTouchEnd={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    id: rowData.get(uid),
                  })
                }
              >
                {/* {strings[action.get('label')]} */}
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        } else {
          const route = `${action.get('route')}${rowData.get(uid)}`;
          const link = props => <Link to={route} {...props} />;
          actions.push(
            <Tooltip
              key={`tooltip-${action.get('route')}-${rowData.get(uid)}`}
              title={strings[action.get('label')] || ''}
              placement="left"
            >
              <IconButton
                component={({ ...props }) => link(props)}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
              >
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        }
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return (
      <>
        <MuiThemeProvider theme={theme}>{actions}</MuiThemeProvider>
      </>
    );
  };

  ActionsColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const ProductColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    try {
      //
      const route = `/products/${rowData.get('productId')}`;
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={cellData}
          component={({ ...props }) => link(props)}
          key={`product-${rowData.get('productId')}`}
          color="primary"
          className="primary"
          style={{ padding: '8px 4px' }}
        >
          {cellData}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  ProductColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const ContractColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    try {
      const contracts = rowData.get('contracts') || fromJS([]);
      cell = contracts.toJS().map(contract => {
        const route = `/contracts/${contract}`;
        const link = props => <Link to={route} {...props} />;
        return (
          <Button
            title={contract}
            type="link"
            key={`product-${contract}`}
            color="primary"
            className="primary"
            component={({ ...props }) => link(props)}
          >
            {contract}
          </Button>
        );
      });
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  ContractColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const PartyColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    const quotation = rowData.toJS();
    if (get(quotation, 'parties', []).length > 0) {
      const parties = get(quotation, 'parties').map(party => (
        <span
          key={`party-${get(party, 'first_name', '')}${get(party, 'name', '')}${get(party, 'email', '')}${get(
            party,
            'birth_date',
            ''
          )}`}
          className={`text ${party ? 'name' : ''}`}
        >
          {`${get(party, 'first_name', '')} ${get(party, 'name', '')}`}
        </span>
      ));
      return parties;
    }
    if (typeof rowData.get('partyId') === 'undefined') return <span className="text name">{cellData}</span>;
    try {
      //
      const route = `/party/${rowData.get('partyId')}`;
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={cellData}
          component={({ ...props }) => link(props)}
          key={`product-${rowData}`}
          color="primary"
          className="party primary"
          style={{ padding: '8px 4px' }}
        >
          {cellData}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  PartyColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const CreatedDateCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    try {
      return <FormatedDate date={cellData} i18n={i18n} />;
    } catch (error) {
      return cellData;
    }
  };

  CreatedDateCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  // eslint-disable-next-line
  const IdColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    let cell;
    if (typeof cellData === 'undefined') return <span className="text name" />;
    try {
      //
      const route = `/quotations/${cellData}`;
      const link = props => <Link to={route} {...props} />;
      cell = cellData ? (
        <Button
          title={cellData.substring(0, 8)}
          component={({ ...props }) => link(props)}
          key={`product-${cellData}`}
          color="primary"
          className="party primary"
          style={{ padding: '4px 4px' }}
        >
          {cellData.substring(0, 8)}
        </Button>
      ) : (
        undefined
      );
    } catch (e) {
      cell = `Invalid link: ${e}`;
    }

    return <>{cell}</>;
  };

  IdColumnCellRenderer.propTypes = {
    cellData: PropTypes.any,
    rowData: PropTypes.any,
    dataKey: PropTypes.any,
    parent: PropTypes.any,
    rowIndex: PropTypes.any,
  };

  return [
    {
      name: 'id',
      label: strings['quotations.grid.column.id.label'] || 'ID',
      width: 90,
      type: 'rendered',
      render: IdColumnCellRenderer,
    },
    {
      name: 'status',
      label: strings['quotations.grid.column.status.label'] || 'Status',
      width: 70,
      type: 'rendered',
      render: StatusColumnCellRenderer,
    },
    // {
    //   name: 'contractQuoteNumber',
    //   label: strings['quotations.grid.column.contractId.label'] || 'Contract',
    //   width: 70,
    //   type: 'rendered',
    //   render: ContractColumnCellRenderer
    // },
    {
      name: 'partyName',
      label: get(strings, 'quotations.grid.column.partyName.label', 'Subscriber'),
      width: 160,
      type: 'rendered',
      render: PartyColumnCellRenderer,
    },
    {
      name: 'createdOn',
      label: strings['quotations.grid.column.createdOn.label'] || 'Creation Date',
      width: 140,
      type: 'rendered',
      render: CreatedDateCellRenderer,
    },
    {
      name: 'commercialProductName',
      label: strings['quotations.grid.column.commercialProductName.label'] || 'Product',
      width: 80,
      type: 'rendered',
      render: ProductColumnCellRenderer,
    },
    {
      name: 'actions',
      label: strings['quotations.grid.column.actions.label'] || 'Actions',
      width: 80,
      type: 'rendered',
      render: ActionsColumnCellRenderer,
    },
  ];
};

const defaultStatusOptions = [
  {
    label: 'project',
    value: 'project',
    strings: 'options.status.project.label',
    color: '',
  },
  {
    label: 'pending',
    value: 'pending',
    strings: 'options.status.pending.label',
    color: '',
  },
  {
    label: 'submitted',
    value: 'submitted',
    strings: 'options.status.submitted.label',
    color: '',
  },
  {
    label: 'canceled',
    value: 'canceled',
    strings: 'options.status.canceled.label',
    color: '',
  },
];
// FILTERS OPTIONS
export const statusOptions = (strings, options = defaultStatusOptions) => {
  const locOptions = [];

  options.forEach(option => {
    locOptions.push({
      value: option.value || option.id,
      label: strings[option.strings] || option.label,
      id: option.id,
      color: option.color,
    });
  });

  return locOptions;
};

// ================
// FILTERS UI
// ================
const getStatusOptions = ({ contractStatus }) => {
  const { selection } = contractStatus;
  return Array.isArray(selection) ? selection.map(option => ({ value: option[0], label: option[1] })) : [];
};

const getCommercialproductsOptions = ({ commercialproducts }) =>
  Array.isArray(commercialproducts)
    ? commercialproducts.map(option => ({
        value: String(option.id),
        label: String(option.name),
      }))
    : [];

export const filtersUI = ({ strings, quotationStatus, commercialproducts }) => ({
  query: {
    value: '',
    label: strings['quotations.filter.query.label'] || 'Filter by Id or Subscriber',
    placeholder: strings['quotations.filter.query.placeholder'] || 'eg. Paul Smith or 34G78... ',
    type: 'text',
    name: 'query',
  },
  status: {
    value: [],
    options: quotationStatus
      ? getStatusOptions({ quotationStatus })
      : [
          {
            label: strings['quotations.filter.status.options.submitted.label'] || 'Submitted',
            value: 'submitted',
          },
          {
            label: strings['quotations.filter.status.options.project.label'] || 'Project',
            value: 'project',
          },
          {
            label: strings['quotations.filter.status.options.canceled.label'] || 'Canceled',
            value: 'canceled',
          },
          {
            label: strings['quotations.filter.status.options.pending.label'] || 'Pending',
            value: 'pending',
          },
        ],
    label: strings['quotations.filter.status.label'] || 'Filter by Status',
    name: 'status',
    type: 'checkbox',
  },
  commercialProductId: {
    value: {
      name: undefined,
      id: undefined,
    },
    options: commercialproducts ? getCommercialproductsOptions({ commercialproducts }) : [],
    label: strings['quotations.filter.product.label'] || 'Filter by Product',
    name: 'commercialProductId',
    type: 'checkbox',
  },
});
